<div class="page-container">
  <mat-card class="main-container mat-elevation-z2">
    <mat-card-title>
      <h1 class="card-title">Seneca Contacts</h1>
      <p>
        We are always happy to help! If you need us, our contact details are
        below.
      </p>
      <!-- <p>We are always happy to help! If you need us, please contact staff assigned to your country of recruitment, our contact details are below.</p> -->
    </mat-card-title>
    <mat-card-content style="margin-left: 40px">
      <div>
        <a
          class="link"
          href="https://www.senecapolytechnic.ca/international/agency-information/new-agencies.html"
          target="_blank"
          >Business Development Managers</a
        >
      </div>
      <br />
      <div>
        <a
          class="link"
          href="https://employees.senecapolytechnic.ca/spaces/284/registered-international-agents/wiki/view/17749/contact-us"
          target="_blank"
          >International Agency and Recruitment Coordinators
        </a>
      </div>
      <br>
    </mat-card-content>
    <!-- <div class="table-wrap">
      <table class="mat-elevation-z8">

        <thead>
          <tr>
            <th>Country</th>
            <th>Job Title</th>
            <th>Contact Name, Email & Phone</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let contact of contactInfo"> 
            <ng-container *ngIf="!contact.newLine" class="contact-wrap">
              <tr >
                <td class="country-field"><strong>{{contact.country}}</strong></td>
                <td>{{contact.jobTitle}}</td>
                <td>
                  <tbody class="inner">
                    <tr>
                      <td><strong>{{contact.contactDetails.name}}</strong></td>
                    </tr>
                    <tr>
                      <td><a href="mailto:{{contact.contactDetails.email}}">{{contact.contactDetails.email}}</a></td>
                    </tr>
                    <tr>
                      <td>{{contact.contactDetails.phone}}</td>
                    </tr>
                  </tbody>
                </td>
              </tr>
            </ng-container>

            <ng-container *ngIf="contact.newLine" >
              <tr class="seperator">
                <td></td>
              </tr>
            </ng-container>
      </ng-container>
    </tbody>
      </table>
    </div> -->

    <br />
    <br />

    <div class="seneca-contact">
      <h2>
        <span style="color: red"><strong>Seneca</strong></span> | International
      </h2>
      <p>1750 Finch Ave. East, Toronto, ON M2J 2X5 Canada</p>
      <p>
        <span>
          <mat-icon>email</mat-icon>
          <a href="mailto:international.agency@senecapolytechnic.ca"
            >international.agency&#64;senecapolytechnic.ca</a
          >
        </span>
      </p>

      <p>
        <span> <mat-icon>phone</mat-icon>+1 (416) 491-5050 Ext. 22608 </span>
      </p>

      <p>
        <span> <mat-icon>print</mat-icon>+1 (416) 498-1524 </span>
      </p>
    </div>
  </mat-card>
</div>
